<template>
  <div class="enter-details">
    <text-input
      :autofocus="true"
      :labelText="'שם פרטי'"
      :value="firstName"
      :onInput="setFirstName"
      :error="false"
      :topLeftLabel="''"/>

    <text-input
      :autofocus="false"
      :labelText="'שם משפחה'"
      :value="lastName"
      :onInput="setLastName"
      :error="false"
      :topLeftLabel="''"/>

    <text-input
      :autofocus="false"
      :labelText="'אימייל'"
      :value="email"
      :onInput="setEmail"
      :inputType="'email'"
      :error="emailError"
      :topLeftLabel="emailErrorLabel"/>

    <text-input
      :autofocus="false"
      :labelText="'טלפון נייד'"
      :value="phoneNumber"
      :onInput="setPhoneNumber"
      :inputType="'text'"
      :inputPattern="'\\d*'"
      :error="!!error"
      :topLeftLabel="phoneNumberErrorLabel"/>
    <check-box v-if="showTerms" :checked="termsAndConditionsAgreed"
               :toggle="toggleTemsAndConditions">
    <template v-slot:title>
      <div class="title">
        קראתי ואישרתי את
        <span class="link" v-on:click="openTermsAndConditions()">תנאי השימוש והפרטיות</span>
      </div>
    </template>
    </check-box>
    <check-box :checked="enableMarketingEmails"
               :toggle="toggleEnableMarketingEmails">
      <template v-slot:title>
        <div class="title">
          אשמח לקבל עדכונים, טיפים וחדשות למייל
        </div>
      </template>
    </check-box>
    <div class="button-container">
      <riseup-button class="send-code-button" :disabled="disabled" :title="buttonTitle" :size="'small'" :action="triggerAction"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import featureFlag from '@/api/featureFlag';
import BaseUI from 'base-ui';
import CheckBox from '@/base-components/CheckBox';
import Segment from '../Segment';

const ERRORS = {
  INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
  INVALID_EMAIL: 'INVALID_EMAIL',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  MEMBER_ALREADY_EXISTS: 'MEMBER_ALREADY_EXISTS',
};

export default {
  name: 'EnterDetails',
  components: {
    TextInput: BaseUI.TextInput,
    RiseupButton: BaseUI.RiseupButton,
    CheckBox,
  },
  async created() {
    this.showTerms = (await featureFlag.getAnonymousTreatment('show_terms_in_intro')) === 'on';
    Segment.trackUserGot('EnterDetailsEntered', { showTerms: this.showTerms });
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      enableMarketingEmails: false,
      termsAndConditionsAgreed: false,
      enteredBadNumber: false,
      emailError: null,
      showTerms: false,
    };
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    error: {
      type: String,
      required: true,
    },
    resetError: {
      type: Function,
      required: true,
    },
    buttonTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    disabled() {
      return (_.trim(this.firstName).length < 2
        || _.trim(this.lastName).length < 2
        || this.enteredBadNumber
        || _.isEmpty(_.trim(this.phoneNumber)))
        || this.email.length < 5
        || this.emailError
        || (this.showTerms && !this.termsAndConditionsAgreed);
    },

    phoneNumberErrorLabel() {
      if (this.error === ERRORS.INVALID_PHONE_NUMBER) {
        Segment.trackUserGot('invalidPhoneNumber', { invalidPhoneNumber: this.phoneNumber });
        this.setBadNumber();
        return 'מספר הטלפון שהזנת לא תקין';
      } if (this.error === ERRORS.MEMBER_ALREADY_EXISTS) {
        this.setBadNumber();
        return 'היי, נראה שכבר הצטרפת בעבר לשירות';
      }
      return null;
    },
    emailErrorLabel() {
      return this.emailError ? 'האימייל שהזנת לא תקין' : null;
    },
    normalizedPhoneNumber() {
      return this.phoneNumber.replace(/\D/g, '');
    },
  },
  methods: {
    setBadNumber() {
      this.enteredBadNumber = true;
    },
    setFirstName(value) {
      this.firstName = value;
    },
    setLastName(value) {
      this.lastName = value;
    },
    setPhoneNumber(value) {
      this.resetError();
      this.phoneNumber = value;
      this.enteredBadNumber = false;
    },
    setEmail(value) {
      this.clearEmailError();
      this.email = value;
    },
    toggleEnableMarketingEmails() {
      this.enableMarketingEmails = !this.enableMarketingEmails;
    },
    toggleTemsAndConditions() {
      this.termsAndConditionsAgreed = !this.termsAndConditionsAgreed;
    },
    triggerAction() {
      this.calcEmailError();
      if (!this.emailError) {
        this.action(this.firstName, this.lastName, this.normalizedPhoneNumber, this.email, this.enableMarketingEmails);
      }
    },
    clearEmailError() {
      this.emailError = null;
    },
    calcEmailError() {
      this.emailError = !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email);
    },
    openTermsAndConditions() {
      window.open('/terms', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../node_modules/base-ui/src/scss/riseup-colors';
  .enter-details {

    .button-container {
      width: 100%;
      margin-top: 5px;
      .send-code-button {
        width: 100%;
      }
    }
    .title {
      padding-top: 5px;
      font-size: 14px;
      margin-right: 20px;

      .link {
        color: $riseup_blue;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .action {
      margin: 36px 0px;
      color: $riseup_blue;
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
      font-size: 16px;
      text-align: center;
    }
  }
</style>
